import { PRE_DELIVERY } from "../const/products";
/**
 * Determines if the pre-delivery message should be displayed
 * - An account must have condition `PRE_DELIVERY`
 * - The `isPreDeliveryMessageEnabled` feature flag must be true
 *
 * @param conditions Optional ConditionValues[] regarding an accounts condition
 * @param featureFlags Optional FeatureFlagsTypes object of flags
 * @returns boolean indicating to show pre-delivery message
 */
var shouldShowPreDeliveryMessage = function (conditions, featureFlags) {
    var _a;
    return (Boolean((_a = conditions === null || conditions === void 0 ? void 0 : conditions.includes) === null || _a === void 0 ? void 0 : _a.call(conditions, PRE_DELIVERY)) &&
        Boolean(featureFlags === null || featureFlags === void 0 ? void 0 : featureFlags.isPreDeliveryMessageEnabled));
};
export default shouldShowPreDeliveryMessage;
//# sourceMappingURL=shouldShowPreDeliveryMessage.js.map